<template>
  <div class="pe-input">
    <pe-icon class="pe-input-icon" :size="iconSize || 22" :weight="iconWeight || 600">{{ icon || 'search' }}</pe-icon>
    <input
      type="text"
      :value="modelValue"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="updateInput"
      class="placeholder-current placeholder:opacity-60"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  modelValue?: number | string
  icon?: string
  iconSize?: number | string
  iconWeight?: number | string
  disabled?: boolean
  placeholder?: string
}>()

const emit = defineEmits(['update:modelValue'])

const updateInput = (event) => {
  emit('update:modelValue', event.target.value)
}
</script>

<style lang="scss" scoped>
.pe-input {
  position: relative;

  input {
    @apply border-0 bg-transparent p-2 text-current outline-none;
    padding-left: 36px;
    width: 0;
    transition: all 0.2s ease-in-out;
    border-bottom: 2px solid transparent;

    &:not(:placeholder-shown),
    &:focus {
      width: 140px;
      @apply border-0 border-b-2 border-solid border-b-current;
    }
  }

  .pe-input-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }
}
</style>
